export const tmStoryGen62 = [
  {
    order: 1,
    title: "Route 104",
    where: "Route 104 – nördlicher Teil der Route, auf der Grasfläche nahe des Blumenladens, sichtbarer Itemball",
    requirements: { badgesNeeded: 0, badges: ["0 Orden"], hms: [] },
    notes: "",
  },

  {
    order: 2,
    title: "Granithöhle",
    where: "Granithöhle – erste große Haupthalle nach dem Eingang, am Rand eines Seitenpfades als Itemball",
    requirements: { badgesNeeded: 1, badges: ["1 Orden"], hms: [] },
    notes: "",
  },

  {
    order: 3,
    title: "Route 113",
    where: "Route 113 – mittlerer Abschnitt der Route, leicht westlich des Glashauses, auf der Aschefläche als Itemball",
    requirements: { badgesNeeded: 3, badges: ["3 Orden"], hms: [] },
    notes: "",
  },
  {
    order: 4,
    title: "Steilpass",
    where: "Steilpass – oberer Südost-Hang, erreichbar über Mach-Bike-Rampe, Itemball auf Felsplateau",
    requirements: { badgesNeeded: 3, badges: ["3 Orden"], hms: ["Mach Bike"] },
    notes: "",
  },
  {
    order: 5,
    title: "Steilpass",
    where: "Steilpass – westlicher Hangbereich, erreichbar über Mach-Bike-Steigung, Itemball am Rand eines Vorsprungs",
    requirements: { badgesNeeded: 3, badges: ["3 Orden"], hms: ["Mach Bike"] },
    notes: "",
  },
  {
    order: 6,
    title: "Feuerpfad",
    where: "Feuerpfad – innerer Höhlenbereich hinter verschiebbaren Felsen, Itemball auf der oberen Plattform",
    requirements: { badgesNeeded: 3, badges: ["3 Orden"], hms: ["Stärke"] },
    notes: "",
  },
  {
    order: 7,
    title: "Schlotberg",
    where: "Schlotberg – Vulkanplateau unterhalb der Seilbahnplattform, Itemball nahe der Felskante",
    requirements: { badgesNeeded: 3, badges: ["3 Orden"], hms: [] },
    notes: "",
  },
  {
    order: 8,
    title: "Granithöhle",
    where: "Granithöhle – tiefer Bereich mit Fahrrad-Passagen, Itemball neben einer Schlammschräge",
    requirements: { badgesNeeded: 3, badges: ["3 Orden"], hms: ["Fahrrad"] },
    notes: "",
  },

  {
    order: 9,
    title: "Route 111",
    where: "Route 111 Wüste – südlicher Teil der Wüste, Itemball nahe eines großen Felsens",
    requirements: { badgesNeeded: 4, badges: ["4 Orden"], hms: [] },
    notes: "",
  },
  {
    order: 10,
    title: "Route 111",
    where: "Route 111 Wüste – nordwestlicher Bereich der Wüste, Itemball auf freier Sandfläche",
    requirements: { badgesNeeded: 4, badges: ["4 Orden"], hms: [] },
    notes: "",
  },

  {
    order: 11,
    title: "Sonnengrotte",
    where: "Route 120 – Sonnengrotte, direkt im inneren Höhlenraum nach dem Surfen erreichbar, Itemball mittig",
    requirements: { badgesNeeded: 5, badges: ["5 Orden"], hms: ["Surfer"] },
    notes: "",
  },
  {
    order: 12,
    title: "Safari-Zone",
    where: "Safari-Zone – nördliches Gebiet nach Bike-Sprüngen, Itemball auf Grasfläche",
    requirements: { badgesNeeded: 5, badges: ["5 Orden"], hms: ["Surfer", "Fahrrad"] },
    notes: "",
  },
  {
    order: 13,
    title: "Safari-Zone",
    where: "Safari-Zone – westlicher Bereich hinter Mud-Slides, Itemball auf erhöhtem Plateau",
    requirements: { badgesNeeded: 5, badges: ["5 Orden"], hms: ["Surfer", "Mach Bike"] },
    notes: "",
  },
  {
    order: 14,
    title: "Safari-Zone",
    where: "Safari-Zone – Inselbereich südlich des Eingangs, Itemball auf kleiner Grasinsel",
    requirements: { badgesNeeded: 5, badges: ["5 Orden"], hms: ["Surfer"] },
    notes: "",
  },

  {
    order: 15,
    title: "Pyroberg",
    where: "Pyroberg – Außenbereich auf halber Höhe des Berges, Itemball auf Treppenplateau",
    requirements: { badgesNeeded: 6, badges: ["6 Orden"], hms: [] },
    notes: "",
  },
  {
    order: 16,
    title: "Küstenhöhle",
    where: "Route 125 – Küstenhöhle bei Ebbe, Eisbereich links vom Eingang, Itemball nahe Eisrampe",
    requirements: { badgesNeeded: 6, badges: ["6 Orden"], hms: ["Surfer"] },
    notes: "",
  },
  {
    order: 17,
    title: "Küstenhöhle",
    where: "Route 125 – Küstenhöhle bei Ebbe, tiefer Innenraum nach Eisrätseln, Itemball neben Leiter",
    requirements: { badgesNeeded: 6, badges: ["6 Orden"], hms: ["Surfer"] },
    notes: "",
  },

  {
    order: 18,
    title: "Seewoge Malvenfroh",
    where: "Route 108 – Sea Mauville, rechter Schiffsteil, Itemball im Raum hinter Türen",
    requirements: { badgesNeeded: 7, badges: ["7 Orden"], hms: ["Surfer", "Taucher"] },
    notes: "",
  },
  {
    order: 19,
    title: "Seewoge Malvenfroh",
    where: "Route 108 – Sea Mauville, Unterdeck nach Taucher-Bereich, Itemball in Seitengang",
    requirements: { badgesNeeded: 7, badges: ["7 Orden"], hms: ["Surfer", "Taucher"] },
    notes: "",
  },
  {
    order: 20,
    title: "Tiefseehöhle",
    where: "Route 128 – Tiefseehöhle, erster großer Raum, Itemball am Rand der Wasserströmungen",
    requirements: { badgesNeeded: 7, badges: ["7 Orden"], hms: ["Surfer", "Taucher"] },
    notes: "",
  },
  {
    order: 21,
    title: "Tiefseehöhle",
    where: "Route 128 – Tiefseehöhle, Raum nahe des legendären Pokémon-Bereichs, Itemball auf Plattform",
    requirements: { badgesNeeded: 7, badges: ["7 Orden"], hms: ["Surfer", "Taucher"] },
    notes: "",
  },
  {
    order: 22,
    title: "Route 132",
    where: "Route 132 – kleine Insel im südwestlichen Strömungsbereich, Itemball mittig der Insel",
    requirements: { badgesNeeded: 7, badges: ["7 Orden"], hms: ["Surfer"] },
    notes: "",
  },
  {
    order: 23,
    title: "Route 134",
    where: "Route 134 – kleine Insel im Strömungsgebiet östlich der Route, Itemball neben Felsformation",
    requirements: { badgesNeeded: 7, badges: ["7 Orden"], hms: ["Surfer"] },
    notes: "",
  },

  {
    order: 24,
    title: "Route 119",
    where: "Route 119 – oberer Bereich hinter Wasserfall, Itemball auf Plateau direkt hinter der Kaskade",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: ["Surfer", "Kaskade"] },
    notes: "",
  },
  {
    order: 25,
    title: "Meteorfälle",
    where: "Meteorfälle – oberer Höhlenbereich nach Wasserfall, Itemball auf Felsplattform",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: ["Surfer", "Kaskade"] },
    notes: "",
  },
  {
    order: 26,
    title: "Siegesstraße",
    where: "Siegesstraße – erster Seitenpfad nach Stärke-Rätsel, Itemball auf erhöhtem Vorsprung",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: ["Stärke"] },
    notes: "",
  },
  {
    order: 27,
    title: "Siegesstraße",
    where: "Siegesstraße – tiefer Höhlenabschnitt nahe Leiterverbindungen, Itemball am Rand der Plattform",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: ["Stärke"] },
    notes: "",
  },
  {
    order: 28,
    title: "Himmelturm",
    where: "Himmelturm – mittlere Turmetage, Itemball auf zerbrochenem Steinboden neben Säule",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: ["Surfer"] },
    notes: "",
  },

  {
    order: 29,
    title: "Wunderwald",
    where: "Mirage-Wald – südlicher Pfad im Waldgebiet, Itemball neben Baumgruppe",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: ["Überflieger"] },
    notes: "",
  },
  {
    order: 30,
    title: "Wunderberg",
    where: "Mirage-Berg – Bike-Sprungplattform nahe Gipfel, Itemball auf Felsplateau",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: ["Überflieger", "Fahrrad"] },
    notes: "",
  },
  {
    order: 31,
    title: "Wundereiland",
    where: "Mirage-Insel – zentrale Grasfläche der Insel, Itemball frei sichtbar",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: ["Überflieger"] },
    notes: "",
  },
];
